import * as React from 'react';
import { FunctionComponent } from 'react';

interface Props {
  affectedSchools: any[];
}

export const AffectedSchoolList: FunctionComponent<Props> = props => {
  const { affectedSchools } = props;

  const schoolsCount = affectedSchools.length;

  const body: React.ReactNodeArray = affectedSchools.map((school, index) => {
    const schoolName = school.schoolName || school.name || '';

    return <li key={`affected_school_list_row_${index}`}>{schoolName}</li>;
  });

  const allUsers = affectedSchools.length;

  return (
    <div className="tTournamentNotificationPreview__schools">
      <div className="tTournamentNotificationPreview__schoolsTitle">
        <span>Recipients</span>
        <strong>
          {allUsers} {allUsers === 1 ? 'school' : 'schools'}
        </strong>
      </div>

      {schoolsCount === 0 ? (
        <div className="tTournamentNotificationPreview__empty">No schools selected</div>
      ) : (
        <ul className="tTournamentNotificationPreview__schoolList">{body}</ul>
      )}
    </div>
  );
};

AffectedSchoolList.displayName = 'AffectedSchoolList';
